import { CarouselRowType } from "../../utils/constants";

const { GENERIC, FEATURED } = CarouselRowType;

export const CarouselRowStyling = {
    [GENERIC]: {
        PARTIAL_VISIBILITY_GUTTER: {
            xs: 50,
            sm: 40,
            md: 30,
            lg: 0,
            xl: 0,
        },
        LAYOUT_ITEMS: {
            xs: 1,
            sm: 2,
            md: 3,
            lg: 4,
            xl: 5,
        },
    },
    [FEATURED]: {
        PARTIAL_VISIBILITY_GUTTER: {
            xs: 0,
            sm: 0,
            md: 0,
            lg: 0,
            xl: 0,
        },
        LAYOUT_ITEMS: {
            xs: 1,
            sm: 1,
            md: 2,
            lg: 2,
            xl: 3,
        },
    },
};
